import { useEffect, useState } from "react"
import { Badge, Card, Table } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import API from "../../common/API"

interface Vehiculo {
    idInterno: string
    vin: string
    estado: string
    estadoTransferencia: string
    tipoVehiculo: string
    marca: string
    modelo: string
    anio: number | null
    color: string
    matricula: string
    nombrePropietario: string
    puertoEntrada: string
    fechaRegistroPlaca: string
    cedulaPropietario: string | null
}

const RecordVehiculos = (props: { id?: string; name?: string }) => {
    const { id, name } = props
    const { t } = useTranslation()
    const [records, setRecords] = useState<Vehiculo[]>([])

    const bindRecords = async () => {
        try {
            // Primary: search by cedula (exact, uses index)
            if (id) {
                const res = await API.postAction("Vehiculos/List", {
                    cedula: id,
                    page: 0,
                    quantity: 20,
                })
                if (res.data.status === "ok" && res.data.response?.length > 0) {
                    setRecords(res.data.response)
                    return
                }
            }
            // Fallback: search by name prefix when cedula yielded nothing
            if (name) {
                const res = await API.postAction("Vehiculos/List", {
                    search: name,
                    page: 0,
                    quantity: 20,
                })
                if (res.data.status === "ok") {
                    setRecords(res.data.response || [])
                }
            }
        } catch (error) {
            console.error("Error fetching vehicle records:", error)
        }
    }

    useEffect(() => {
        if (id || name) bindRecords()
    }, [id, name])

    if (records.length === 0) return null

    return (
        <Card className="my-4">
            <Card.Header className="display-4">
                <i className="fas fa-car me-2" />
                {t("Vehículos")}
            </Card.Header>
            <Card.Body className="p-3">
                <div style={{ overflowX: "auto" }}>
                    <Table size="sm" bordered hover className="small mb-0">
                        <thead className="table-dark">
                            <tr>
                                <th>{t("Tipo")}</th>
                                <th>{t("Marca / Modelo")}</th>
                                <th>{t("Año")}</th>
                                <th>{t("Color")}</th>
                                <th>{t("Matrícula")}</th>
                                <th>{t("VIN")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {records.map((v, i) => (
                                <tr key={i}>
                                    <td>{v.tipoVehiculo}</td>
                                    <td className="fw-semibold">{v.marca} {v.modelo}</td>
                                    <td>{v.anio ?? "—"}</td>
                                    <td>{v.color}</td>
                                    <td>{v.matricula}</td>
                                    <td><small className="text-muted">{v.vin}</small></td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </Card.Body>
        </Card>
    )
}

export default RecordVehiculos
